import styles from "./GlobalSearch.module.css";

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

type HighlightMatchProps = {
  text: string;
  query: string;
};

/** Wraps every case-insensitive occurrence of `query` in `text` with <mark>. */
export function HighlightMatch({ text, query }: HighlightMatchProps) {
  const needle = query.trim();
  if (!needle) return <>{text}</>;

  // Splitting on a capturing group keeps the matches at the odd indexes.
  const parts = text.split(new RegExp(`(${escapeRegExp(needle)})`, "gi"));

  return (
    <>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <mark key={index} className={styles.match}>
            {part}
          </mark>
        ) : (
          part
        ),
      )}
    </>
  );
}
